<template>
        <card>
           <template slot="header">
              <div class="row">
                 <div class="col-md-2">
                    <h3 class="card-title">Designations </h3>
                 </div>
              </div>
           </template>
           <div class="row">
              <div class="col-md-6">
                <nav class="row">
                    <ol class="breadcrumb arr-right bg-breadcrum">
                       <li class="breadcrumb-item">
                          <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                       </li>
                       <li class="breadcrumb-item active">Designations</li>
                    </ol>
                 </nav>
              </div>
              <div class="col-md-6">
                 <button class="btn  btn-primary float-right" v-b-modal.add-new-item><i class="fa fa-plus"></i> New Designation</button>
              </div>
           </div>
           <div class="table-responsive ">
              <table class="table table-striped" v-loading="loading">
                 <tbody>
                    <tr v-for="item in positionData">
                            <template v-if="item === 'no data found'">
                               <td colspan="100%"><h4>  <i class="fa fa-database"></i> Empty Records ...</h4></td>  
                            </template> 
                            <template v-else>        
                            <td>
                                <a href="#" @click="get_selected_id(item)" class="link-default-positions" v-b-modal.update-positions v-b-tooltip.hover title="click to update designation item and position name"><u>{{item.pos_name | capitalize}}</u></a> 
                                <br/><i>{{item.dep_name | capitalize}}</i>
                            </td>
                            <td v-text="item.created_at"></td>
                            <td v-text="item.updated_at"></td>
                            <td>
                                <h4><i class="fa fa-user"></i>&nbsp; Employees&nbsp;<span class="badge badge-pill badge-danger">{{item.emp}}</span></h4>
                            </td>
                         </template> 
                    </tr>
                 </tbody>
              </table>
              <!-- ADD NEW ITEM -->
              <b-modal id="add-new-item"  ref="add-new-positions" size="l"   title="Add New Position"  hide-footer>
                 <h3>Job Position</h3>
                 <div class="form-group">
                    <label>Deparment Name:</label>
                    <select class="form-control" v-model="department_id">
                       <option value="" disabled>-- Select Department --</option>
                       <option v-for="dep in department_items" v-bind:value="dep.dep_id">{{dep.department}}</option>
                    </select>
                 </div>
                 <div class="form-group">
                    <label>Position Name:</label>
                    <input type="text" class="form-control" v-model="position_name">
                 </div>
                 <div class="form-group">
                    <button class="btn btn-info float-right" @click="add_pos_name"><i class="fa fa-save"></i> Submit form</button>
                 </div>
              </b-modal>
              <!-- MODAL FOR UPDATE RECORD  -->
              <b-modal id="update-positions" ref="hide-positions"  size="l"   title="Update Item"  hide-footer>
                 <h3>Job Position</h3>
                 <div class="form-group">
                    <label>Deparment Name:</label>
                    <select class="form-control" v-model="selected_user.dep_id">
                       <option v-for="dep in department_items" v-bind:value="dep.dep_id">{{dep.department}}</option>
                    </select>
                 </div>
                 <div class="form-group">
                    <label>Position Name:</label>
                    <input type="text" class="form-control" v-model="selected_user.pos_name">
                 </div>
                 <div class="form-group">
                    <button class="btn btn-info float-right" @click="update_positions"><i class="fa fa-save"></i> Save Changes</button>
                 </div>
              </b-modal>
           </div>
            <!-- If Lost Connection on Server -->   
            <template v-if="display_indicator === 1">
                <center>
                    <br/><br/>
                    <img  src="/static/img/warning.png"  width="225" height="190">
                <h1>You've lost your network connection</h1>
                <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
                <br/><br/>
            </center>
         </template>
        </card>
     </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'                     
export default {
   components: {
      Card,
   },

   data() {
      return {
         department_items: [],
         position_items: [],
         department_id: '',
         position_name: '',
         selected_user: '',
         loading: true,
         //Indicator
         display_indicator:''
      }
   },

    mounted: function() {
      this.get_departments()
      this.get_positions()
   },

   methods: {
   
      get_positions() {
        axios.get('api/positions') 
            .then(response => {
               this.position_items = response.data;
               this.display_indicator = 2;
               this.loading = false;
            })
            .catch(error => {
               console.log(error)
               this.display_indicator = 1;
            });

      },
      get_departments() {
        axios.get('api/departments')   
            .then(response => {
               this.department_items = response.data;
            })
            .catch(error => {
               console.log(error)
            });
      },
      add_pos_name() {
         axios.post('api/positions/add', {
               position_name: this.position_name,
               department_id: this.department_id
            })
            .then(response => {
               this.$swal({
                  type: 'success',
                  title: 'Save',
                  text: 'You successfully save',
                  showConfirmButton: false,
                  timer: 2000
               })
               //this.pos_name = ''
               this.get_positions();
               this.$refs['add-new-positions'].hide();
               console.log(response)
            })
            .catch(error => {
               console.log(error)
            });


      },
      get_selected_id(pos) {
         this.selected_user = pos;
      },
      update_positions() {
         axios.post('api/positions/update/' + this.selected_user.pos_id, {
               position_name: this.selected_user.pos_name,
               department_id: this.selected_user.dep_id
            })
            .then(response => {
               this.$swal({
                  type: 'success',
                  title: 'Save',
                  text: 'You successfully save',
                  showConfirmButton: false,
                  timer: 2000
               })
               this.pos_name = ''
               this.get_positions();
               this.$refs['hide-positions'].hide();
               console.log(response)
            })
            .catch(error => {
               console.log(error)
            });

      }
   },

   computed: {
        positionData(){
            let filterd = this.position_items;
                if(filterd.length > 0){
                    filterd.slice().reverse()
                }  
            return filterd;
        }, 
   },


}
</script>
<style>
        .fa-update{
            color:#07b22c;
            font-size:19px;
        }
        .bg-breadcrum{
            background:#fff;
        }
        .link-default-positions{
            color: #666;
            font-size: 25px;
            font-weight: 500;
            line-height: 1.1;
        }

</style>     
                
        
                


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-positions/todo-position.vue